import { Loader2, Pencil, Upload } from "lucide-react";
import { Button } from "@/modern/components/ui/button";
import { cn } from "@/modern/utils";
import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import { navigateToViewByType } from "@/other/utils/asyncTaskUtils.jsx";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useMarketingPagesContext } from "../context/MarketingPagesContext";
import { isSiteLive } from "../utils";

export function MarketingPagesToolbar() {
  const { viewManager } = useSwivuBryntumContext();
  const {
    siteRecord,
    ensureSiteRecord,
    isPublishing,
    isRepublishing,
  } = useMarketingPagesContext();

  const isLive = isSiteLive(siteRecord);
  const isBusy = isPublishing || isRepublishing;

  const navigateToSite = () => {
    ensureSiteRecord();
    navigateToViewByType(viewManager, VIEW_TYPES.site, "Site", {});
  };

  const ctaLabel = isBusy
    ? isRepublishing
      ? "Republishing…"
      : "Publishing…"
    : isLive
      ? "Edit site"
      : "Publish Site";

  return (
    <div className="ml-auto flex shrink-0 flex-wrap items-center justify-end gap-2">
      <Button
        type="button"
        size="sm"
        variant={isLive ? "outline" : "default"}
        className="h-8 gap-1.5"
        onClick={navigateToSite}
        disabled={isBusy}
      >
        {isBusy ? (
          <Loader2 className="size-3.5 animate-spin" />
        ) : isLive ? (
          <Pencil className="size-3.5" />
        ) : (
          <Upload className="size-3.5" />
        )}
        {ctaLabel}
        {isLive && !isBusy && (
          <span
            className={cn(
              "rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none",
              "bg-success/15 text-success",
            )}
          >
            Live
          </span>
        )}
      </Button>
    </div>
  );
}
